import { GET_OBJECTIVES, GET_OBJECTIVE, UPDATE_OBJECTIVES, DELETE_OBJECTIVES, GET_RELATED_OBJECTIVES } from "../constants/action-types";
import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { ObjectiveType } from "../constants/ObjectiveConstants";

const API_CONFIG = getApiConfig();

/*
  Get objectives.
*/
export const getObjectives = (objectiveTypes, callback) => (dispatch) => {
  let queryParam = "";

  objectiveTypes.forEach(objectiveType => {
    if (queryParam.length == 0) {
      queryParam = `?`
    } else {
      queryParam = `${queryParam}&`
    }
    switch (objectiveType) {
      case ObjectiveType().admin.key:
        queryParam = `${queryParam}admin=true`;
        break;
      case ObjectiveType().admin_route.key:
        queryParam = `${queryParam}adminRoute=true`;
        break;
      default:
        break;
    }
  });

  
  adalApiFetch(Axios, `${API_CONFIG.URL}/objectives${queryParam}`, {
    method: "GET",
  })
    .then((res) => {
      dispatch({
        type: GET_OBJECTIVES,
        payload: res.data,
      });

      callback(true);
    })
    .catch((error) => {
      console.log("Exception occurred", error);
      callback(false);
    });
};

/*
  Get objectives.
*/
export const getObjective = (objectiveId, callback) => (dispatch) => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/objectives/${objectiveId}`, {
    method: "GET",
  })
    .then((res) => {
      dispatch({
        type: GET_OBJECTIVE,
        payload: res.data,
      });

      callback(res.data);
    })
    .catch((error) => {
      console.log("Exception occurred", error);
      callback(null);
    });
};

/*
  Get related objectives.
*/
export const getRelatedObjectives = (objectiveId, callback) => (dispatch) => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/objectives?parentObjectiveId=${objectiveId}`, {
    method: "GET",
  })
    .then((res) => {
      dispatch({
        type: GET_RELATED_OBJECTIVES,
        payload: res.data,
      });

      callback(res.data);
    })
    .catch((error) => {
      console.log("Exception occurred", error);
      callback(null);
    });
};


/*
  Delete form.
*/
export const deleteObjectives = (data, callback) => dispatch => {
  const headers = { "Content-Type": "application/json" };

  adalApiFetch(Axios, `${API_CONFIG.URL}/objectives`, {
    method: "DELETE",
    data: data,
    headers
  })
    .then(res => {
      dispatch({
        type: DELETE_OBJECTIVES,
        payload: data
      });
      callback(true);
    })
    .catch(error => {
      console.log("Exception occurred", error);
      callback(false);
    });
};


/*
  Update/create objective.
*/
export const updateObjectives = (objective, callback) => (dispatch) => {
  handleModification("PUT", objective, callback, dispatch);
};

/*
  Update/create objective.
*/
export const createObjectives = (objective, callback) => (dispatch) => {
  handleModification("POST", objective, callback, dispatch);
};


function handleModification(method, objectives, callback, dispatch) {
  const headers = { "Content-Type": "application/json" };

  if (objectives != null && objectives != undefined) {
    adalApiFetch(Axios, `${API_CONFIG.URL}/objectives`, {
      method: method,
      data: objectives,
      headers,
    })
      .then((res) => {
        dispatch({
          type: UPDATE_OBJECTIVES,
          payload: objectives,
        });

        callback(true);
      })
      .catch((error) => {
        console.log("Exception occurred", error);
        callback(false);
      });
  } else {
    callback(false);
  }
}
